import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ArticlePreview from "@components/ArticlePreview/ArticlePreview.component";
import { flexCenter } from "@components/mixins";
import { useFetch } from "@utils/hooks";
import SpinnerComponent from "@components/Spinner/Spinner.component";

const ArticlesWrapper = styled.div`
    ${flexCenter};
    align-items: flex-start;
    flex-wrap: wrap;
`;

const ArticlesContainer = (props) => {
    const { data, loading, error } = useFetch(
        "https://admin.magazynzdrowedziecko.pl/articles?_sort=position:DESC"
    );

    const articles = data?.map(
        ({ id, Title: title, Lead: lead, Image: img, slug }) => (
            <ArticlePreview
                key={id}
                big={id % 4 === 1 || id % 4 === 0}
                title={title}
                lead={lead}
                imgSet={img}
                slug={slug}
            />
        )
    );

    if (error) {
        return <h2>Coś poszło nie tak.</h2>;
    }

    return (
        <ArticlesWrapper>
            {loading ? <SpinnerComponent /> : articles}
        </ArticlesWrapper>
    );
};

export default ArticlesContainer;
